import { useEffect, useState } from "react";
import { Users, UserPlus, PoundSterling, TrendingUp, Camera, Image as ImageIcon, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function AdminOverview() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/overview").then((r) => {
      setData(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16" data-testid="admin-overview-loading">
        <Loader2 className="w-8 h-8 text-[#D4A853] animate-spin" />
      </div>
    );
  }

  if (!data) return null;

  const sym = data.currency_symbol || "£";

  const cards = [
    { icon: Users, label: "Total users", value: data.total_users, accent: false },
    { icon: UserPlus, label: "Users this month", value: data.users_this_month, accent: false },
    { icon: PoundSterling, label: "Total revenue", value: `${sym}${data.total_revenue_gbp.toLocaleString()}`, accent: true },
    { icon: TrendingUp, label: "Revenue this month", value: `${sym}${data.revenue_this_month_gbp.toLocaleString()}`, accent: true },
    { icon: Camera, label: "Reference photos", value: data.reference_photos, accent: false },
    { icon: ImageIcon, label: "AI images uploaded", value: data.generated_images, accent: false },
  ];

  return (
    <div data-testid="admin-overview">
      <span className="eyebrow">Overview</span>
      <h1 className="font-display text-3xl md:text-4xl text-[#1A1F3D] mt-2">Business at a glance</h1>
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map((c, i) => (
          <div
            key={i}
            className={`bsp-card p-6 flex items-center gap-4 ${c.accent ? "border-l-4 border-[#D4A853]" : ""}`}
            data-testid={`stat-${c.label.replace(/\s+/g, "-").toLowerCase()}`}
          >
            <div className="w-12 h-12 rounded-xl bg-[#F5E6E0] flex items-center justify-center shrink-0">
              <c.icon className="w-5 h-5 text-[#1A1F3D]" strokeWidth={1.6} />
            </div>
            <div>
              <div className="font-display text-3xl text-[#1A1F3D]">{c.value}</div>
              <div className="text-xs uppercase tracking-wider font-semibold text-[#52525b] mt-0.5">{c.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
